import { Button } from '@travelnest/merlin.button';
import { Modal } from '@travelnest/merlin.modal';
import theme from '@travelnest/merlin.theme';
import { Paragraph } from '@travelnest/merlin.typography';
import React, { useState } from 'react';

interface IChargeHostCancellationModalProps {
	onRequestClose: () => any;
	chargeHostCancellation: () => any;
}

export const ChargeHostCancellationModal: React.FC<
	IChargeHostCancellationModalProps
> = ({ onRequestClose, chargeHostCancellation }) => {
	const [isChargingHost, setIsChargingHost] = useState(false);
	const onConfirm = async () => {
		setIsChargingHost(true);
		await chargeHostCancellation();
		setIsChargingHost(false);
		onRequestClose();
	};

	return (
		<Modal
			title="Charge Host Cancellation"
			shouldCloseOnOverlayClick={true}
			onRequestClose={onRequestClose}
			actionRHS={
				<Button
					loading={isChargingHost}
					id="charge_host_cancellation_confirm"
					onClick={onConfirm}
					bgColor={theme.colours.success.default}
					color={theme.colours.text.light}
				>
					Confirm
				</Button>
			}
		>
			<div className="booking_refresh_content">
				<Paragraph>
					Please confirm that you wish to immediately charge this host £160 for
					the cancellation.
				</Paragraph>
			</div>
		</Modal>
	);
};
